// import React from "react";
// import { Link } from "react-router-dom";
// import {  FiShoppingCart, FiEye, FiStar } from "react-icons/fi";
// import "../../pages/Home/Home.css";

// const ProductCard = ({ product }) => {
//   return (
//     <div className="product-card">
//       {product.discount && (
//         <span className="discount-badge">{product.discount}% OFF</span>
//       )}
//       <Link to={`/product/${product.id}`}>
//         <div className="product-image">
//           <img src={product.image} alt={product.title} />
//         </div>
//       </Link>
//       <div className="product-content">
//         <span className="product-category">{product.category}</span>

//         <Link to={`/product/${product.id}`} className="product-title">
//           {product.title}
//         </Link>
//         <div className="product-rating">
//           <FiStar />
//           <FiStar />
//           <FiStar />
//           <FiStar />
//           <FiStar />

//           <span>({product.reviews || 25})</span>
//         </div>
//         <div className="product-price">
//           <span className="new-price">{product.price}</span>

//           {product.oldPrice && (
//             <span className="old-price">{product.oldPrice}</span>
//           )}
//         </div>
//         <div className="product-buttons">
//        <button className="cart-btn">
//   <FiShoppingCart />
//   <span>Add Cart</span>
// </button>
//           <Link to={`/product/${product.id}`} className="view-btn">
//             <FiEye />
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;



// // api i ntegrated
// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FiShoppingCart,
//   FiEye,
//   FiStar,
// } from "react-icons/fi";

// import "../../pages/Home/Home.css";
// import BASE_URL from "../../config";

// // --------------------------------------------------
// // API BASE URL
// // BASE_URL = https://astrologicalsolutions.astrologicalsolutions.in/api/v1
// // Image URL ke liye /api/v1 remove karna hai
// // --------------------------------------------------
// const IMAGE_BASE_URL = BASE_URL.replace("/api/v1", "");

// const ProductCard = ({ product }) => {

//   // --------------------------------------------------
//   // PRIMARY PRODUCT IMAGE
//   // --------------------------------------------------
//   const primaryImage =
//     product?.images?.find((img) => img?.isPrimary)?.imageUrl ||
//     product?.images?.[0]?.imageUrl ||
//     product?.image ||
//     "";

//   // --------------------------------------------------
//   // COMPLETE IMAGE URL
//   // --------------------------------------------------
//   const productImage = primaryImage
//     ? primaryImage.startsWith("http")
//       ? primaryImage
//       : `${IMAGE_BASE_URL}${primaryImage}`
//     : "/placeholder-product.jpg";





    
//   // --------------------------------------------------
//   // PRODUCT PRICE
//   // --------------------------------------------------
//   const price = parseFloat(product?.price);

//   const finalPrice = Number.isFinite(price)
//     ? price
//     : 0;

//   // --------------------------------------------------
//   // OLD PRICE / MRP
//   // Backend mein agar mrp / oldPrice available ho
//   // --------------------------------------------------
//   const oldPriceValue =
//     product?.mrp ??
//     product?.oldPrice ??
//     product?.compareAtPrice ??
//     null;

//   const oldPrice = oldPriceValue
//     ? parseFloat(oldPriceValue)
//     : null;

//   // --------------------------------------------------
//   // DISCOUNT
//   // --------------------------------------------------
//   let discount = null;

//   if (product?.discountPercent) {
//     discount = Number(product.discountPercent);
//   } else if (
//     oldPrice &&
//     oldPrice > finalPrice
//   ) {
//     discount = Math.round(
//       ((oldPrice - finalPrice) / oldPrice) * 100
//     );
//   }

//   // --------------------------------------------------
//   // PRODUCT CATEGORY
//   // --------------------------------------------------
//   const categoryName =
//     product?.category?.name ||
//     product?.subcategory?.name ||
//     "Spiritual Product";

//   // --------------------------------------------------
//   // PRODUCT NAME
//   // --------------------------------------------------
//   const productName =
//     product?.name ||
//     product?.title ||
//     "Product";

//   // --------------------------------------------------
//   // REVIEWS
//   // --------------------------------------------------
//   const reviewCount =
//     Number(
//       product?.reviewCount ??
//       product?.reviews ??
//       product?.totalReviews ??
//       0
//     );

//   // --------------------------------------------------
//   // RATING
//   // --------------------------------------------------
//   const rating =
//     Number(
//       product?.rating ??
//       product?.averageRating ??
//       0
//     );

//   return (
//     <div className="product-card">

//       {/* ==========================================
//           DISCOUNT BADGE
//       ========================================== */}
//       {discount > 0 && (
//         <span className="discount-badge">
//           {discount}% OFF
//         </span>
//       )}

//       {/* ==========================================
//           PRODUCT IMAGE
//       ========================================== */}
//       <Link to={`/product/${product?.id}`}>

//         <div className="product-image">

//           <img
//             src={productImage}
//             alt={productName}
//             onError={(e) => {
//               e.currentTarget.onerror = null;
//               e.currentTarget.src =
//                 "/placeholder-product.jpg";
//             }}
//           />

//         </div>

//       </Link>


//       {/* ==========================================
//           PRODUCT CONTENT
//       ========================================== */}
//       <div className="product-content">

//         {/* CATEGORY */}
//         <span className="product-category">
//           {categoryName}
//         </span>


//         {/* PRODUCT NAME */}
//         <Link
//           to={`/product/${product?.id}`}
//           className="product-title"
//         >
//           {productName}
//         </Link>


//         {/* ========================================
//             RATING
//         ======================================== */}
//         <div className="product-rating">

//           <FiStar
//             className={rating >= 1 ? "filled" : ""}
//           />

//           <FiStar
//             className={rating >= 2 ? "filled" : ""}
//           />

//           <FiStar
//             className={rating >= 3 ? "filled" : ""}
//           />

//           <FiStar
//             className={rating >= 4 ? "filled" : ""}
//           />

//           <FiStar
//             className={rating >= 5 ? "filled" : ""}
//           />

//           <span>
//             ({reviewCount})
//           </span>

//         </div>


//         {/* ========================================
//             PRICE
//         ======================================== */}
//         <div className="product-price">

//           <span className="new-price">
//             ₹{finalPrice.toLocaleString("en-IN")}
//           </span>

//           {oldPrice &&
//             oldPrice > finalPrice && (
//               <span className="old-price">
//                 ₹{oldPrice.toLocaleString("en-IN")}
//               </span>
//             )}

//         </div>


//         {/* ========================================
//             BUTTONS
//         ======================================== */}
//         <div className="product-buttons">

//           {/* ADD CART */}
//           <button
//             type="button"
//             className="cart-btn"
//             onClick={() => {
//               console.log(
//                 "Add to cart:",
//                 product
//               );
//             }}
//           >
//             <FiShoppingCart />

//             <span>
//               Add Cart
//             </span>
//           </button>


//           {/* VIEW PRODUCT */}
//           <Link
//             to={`/product/${product?.id}`}
//             className="view-btn"
//             aria-label={`View ${productName}`}
//           >
//             <FiEye />
//           </Link>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ProductCard;













// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   FiShoppingCart,
//   FiEye,
//   FiStar,
// } from "react-icons/fi";

// import "../../pages/Home/Home.css";
// import BASE_URL from "../../config";

// // ==========================================
// // IMAGE BASE URL
// // ==========================================
// const IMAGE_BASE_URL = BASE_URL
//   .replace(/\/api\/v1\/?$/, "")
//   .replace(/\/$/, "");

// // ==========================================
// // PLACEHOLDER
// // ==========================================
// const PLACEHOLDER_IMAGE = "/placeholder-product.jpg";

// // ==========================================
// // IMAGE URL HELPER
// // ==========================================
// export const getProductImage = (image) => {
//   if (!image || typeof image !== "string") {
//     return PLACEHOLDER_IMAGE;
//   }

//   const cleanImage = image.trim();

//   if (!cleanImage) {
//     return PLACEHOLDER_IMAGE;
//   }

//   // Already complete URL
//   if (
//     cleanImage.startsWith("http://") ||
//     cleanImage.startsWith("https://") ||
//     cleanImage.startsWith("data:")
//   ) {
//     return cleanImage;
//   }

//   // Backend image path
//   if (cleanImage.startsWith("/")) {
//     return `${IMAGE_BASE_URL}${cleanImage}`;
//   }

//   return `${IMAGE_BASE_URL}/${cleanImage}`;
// };

// // ==========================================
// // PRODUCT CARD
// // ==========================================
// const ProductCard = ({ product }) => {
//   const [imageError, setImageError] = useState(false);

//   // ========================================
//   // PRIMARY IMAGE
//   // ========================================
//   const primaryImage =
//     product?.images?.find(
//       (img) =>
//         img?.isPrimary === true ||
//         img?.isPrimary === 1
//     )?.imageUrl ||
//     product?.images?.[0]?.imageUrl ||
//     product?.image ||
//     "";

//   // ========================================
//   // PRODUCT IMAGE
//   // ========================================
//   const productImage = imageError
//     ? PLACEHOLDER_IMAGE
//     : getProductImage(primaryImage);

//   // ========================================
//   // PRICE
//   // ========================================
//   const price = parseFloat(product?.price);

//   const finalPrice = Number.isFinite(price)
//     ? price
//     : 0;

//   // ========================================
//   // OLD PRICE
//   // ========================================
//   const oldPriceValue =
//     product?.mrp ??
//     product?.oldPrice ??
//     product?.compareAtPrice ??
//     null;

//   const oldPrice = oldPriceValue
//     ? parseFloat(oldPriceValue)
//     : null;

//   // ========================================
//   // DISCOUNT
//   // ========================================
//   let discount = null;

//   if (product?.discountPercent) {
//     discount = Number(product.discountPercent);
//   } else if (
//     oldPrice &&
//     oldPrice > finalPrice
//   ) {
//     discount = Math.round(
//       ((oldPrice - finalPrice) / oldPrice) * 100
//     );
//   }

//   // ========================================
//   // CATEGORY
//   // ========================================
//   const categoryName =
//     product?.category?.name ||
//     product?.subcategory?.name ||
//     "Spiritual Product";

//   // ========================================
//   // PRODUCT NAME
//   // ========================================
//   const productName =
//     product?.name ||
//     product?.title ||
//     "Product";

//   // ========================================
//   // REVIEWS (reviewSummary comes from the backend's per-product aggregate —
//   // product.rating/reviews were never populated by the API, so those are
//   // kept only as a fallback for any caller still passing old-shaped data)
//   // ========================================
//   const reviewCount = Number(
//     product?.reviewSummary?.totalReviews ??
//       product?.reviewCount ??
//       product?.reviews ??
//       product?.totalReviews ??
//       0
//   );

//   // ========================================
//   // RATING
//   // ========================================
//   const rating = Number(
//     product?.reviewSummary?.averageRating ??
//       product?.rating ??
//       product?.averageRating ??
//       0
//   );

//   // ========================================
//   // IMAGE ERROR HANDLER
//   // ========================================
//   const handleImageError = (e) => {
//     // Prevent repeated fallback
//     if (e.currentTarget.dataset.fallback === "true") {
//       return;
//     }

//     e.currentTarget.dataset.fallback = "true";

//     setImageError(true);
//   };

//   return (
//     <div className="product-card">

//       {/* ======================================
//           DISCOUNT
//       ====================================== */}
//       {discount > 0 && (
//         <span className="discount-badge">
//           {discount}% OFF
//         </span>
//       )}

//       {/* ======================================
//           PRODUCT IMAGE
//       ====================================== */}
//       <Link to={`/product/${product?.id}`}>
//         <div className="product-image">

//           <img
//             src={productImage}
//             alt={productName}
//             loading="lazy"
//             onError={handleImageError}
//           />

//         </div>
//       </Link>

//       {/* ======================================
//           PRODUCT CONTENT
//       ====================================== */}
//       <div className="product-content">

//         {/* CATEGORY */}
//         <span className="product-category">
//           {categoryName}
//         </span>

//         {/* NAME */}
//         <Link
//           to={`/product/${product?.id}`}
//           className="product-title"
//         >
//           {productName}
//         </Link>

//         {/* ====================================
//             RATING
//         ==================================== */}
//         <div className="product-rating">

//           <FiStar
//             className={
//               rating >= 1 ? "filled" : ""
//             }
//           />

//           <FiStar
//             className={
//               rating >= 2 ? "filled" : ""
//             }
//           />

//           <FiStar
//             className={
//               rating >= 3 ? "filled" : ""
//             }
//           />

//           <FiStar
//             className={
//               rating >= 4 ? "filled" : ""
//             }
//           />

//           <FiStar
//             className={
//               rating >= 5 ? "filled" : ""
//             }
//           />

//           <span>
//             ({reviewCount})
//           </span>

//         </div>

//         {/* ====================================
//             PRICE
//         ==================================== */}
//         <div className="product-price">

//           <span className="new-price">
//             ₹{finalPrice.toLocaleString("en-IN")}
//           </span>

//           {oldPrice &&
//             oldPrice > finalPrice && (
//               <span className="old-price">
//                 ₹{oldPrice.toLocaleString("en-IN")}
//               </span>
//             )}

//         </div>

//         {/* ====================================
//             BUTTONS
//         ==================================== */}
//         <div className="product-buttons">

//           {/* ADD CART */}
//           <button
//             type="button"
//             className="cart-btn"
//             onClick={() => {
//               console.log(
//                 "Add to cart:",
//                 product
//               );
//             }}
//           >
//             <FiShoppingCart />

//             <span>
//               Add Cart
//             </span>
//           </button>

//           {/* VIEW */}
//            <Link
//             to={`/product/${product?.id}`}
//             className="view-btn"
//             aria-label={`View ${productName}`}
//           >
//             <FiEye />
//           </Link>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ProductCard;



import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiShoppingCart,
  FiEye,
  FiStar,
} from "react-icons/fi";

import "../../pages/Home/Home.css";
import BASE_URL from "../../config";
import { useCart } from "../../context/CartContext";

const IMAGE_BASE_URL = BASE_URL
  .replace(/\/api\/v1\/?$/, "")
  .replace(/\/$/, "");

const PLACEHOLDER_IMAGE = "/placeholder-product.jpg";

export const getProductImage = (image) => {
  if (!image || typeof image !== "string") {
    return PLACEHOLDER_IMAGE;
  }

  const cleanImage = image.trim();

  if (!cleanImage) return PLACEHOLDER_IMAGE;

  if (/^(https?:\/\/|data:|blob:)/i.test(cleanImage)) {
    return cleanImage;
  }

  if (cleanImage.startsWith("/")) {
    return `${IMAGE_BASE_URL}${cleanImage}`;
  }

  return `${IMAGE_BASE_URL}/${cleanImage}`;
};

const ProductCard = ({ product }) => {
  const [imageError, setImageError] = useState(false);
  const [added, setAdded] = useState(false);

  // CART CONTEXT
  const { addToCart } = useCart();

  const primaryImage =
    product?.images?.find(
      (img) =>
        img?.isPrimary === true ||
        img?.isPrimary === 1
    )?.imageUrl ||
    product?.images?.[0]?.imageUrl ||
    product?.image ||
    "";

  const productImage = imageError
    ? PLACEHOLDER_IMAGE
    : getProductImage(primaryImage);

  const price = parseFloat(product?.price);

  const finalPrice = Number.isFinite(price)
    ? price
    : 0;

  const oldPriceValue =
    product?.mrp ??
    product?.oldPrice ??
    product?.compareAtPrice ??
    null;

  const oldPrice = oldPriceValue
    ? parseFloat(oldPriceValue)
    : null;

  let discount = null;

  if (product?.discountPercent) {
    discount = Number(product.discountPercent);
  } else if (oldPrice && oldPrice > finalPrice) {
    discount = Math.round(
      ((oldPrice - finalPrice) / oldPrice) * 100
    );
  }

  const categoryName =
    product?.category?.name ||
    product?.category ||
    product?.subcategory?.name ||
    "Spiritual Product";

  const productName =
    product?.name ||
    product?.title ||
    "Product";

  const reviewCount = Number(
    product?.reviewSummary?.totalReviews ??
    product?.reviewCount ??
    product?.reviews ??
    product?.totalReviews ??
    0
  );

  const rating = Number(
    product?.reviewSummary?.averageRating ??
    product?.rating ??
    product?.averageRating ??
    0
  );

  // ========================================
  // ADD TO CART FUNCTION
  // ========================================

  const handleAddToCart = () => {
    if (!product?.id) {
      console.error("Product ID missing");
      return;
    }

    addToCart({
      productId: product.id,
      title: productName,
      image: productImage,
      quantity: 1,
      unitPrice: finalPrice,
      selectedChoiceIds: [],
      optionsLabel: "",
    });

    setAdded(true);
  };

  const handleImageError = (e) => {
    if (e.currentTarget.dataset.fallback === "true") {
      return;
    }

    e.currentTarget.dataset.fallback = "true";
    setImageError(true);
  };

  return (
    <div className="product-card">

      {discount > 0 && (
        <span className="discount-badge">
          {discount}% OFF
        </span>
      )}

      {/* PRODUCT IMAGE */}

      <Link to={`/product/${product?.id}`}>
        <div className="product-image">
          <img
            src={productImage}
            alt={productName}
            loading="lazy"
            onError={handleImageError}
          />
        </div>
      </Link>

      {/* PRODUCT CONTENT */}

      <div className="product-content">

        <span className="product-category">
          {categoryName}
        </span>

        <Link
          to={`/product/${product?.id}`}
          className="product-title"
        >
          {productName}
        </Link>

        {/* RATING */}

        <div className="product-rating">

          {[1, 2, 3, 4, 5].map((star) => (
            <FiStar
              key={star}
              className={rating >= star ? "filled" : ""}
            />
          ))}

          <span>({reviewCount})</span>

        </div>

        {/* PRICE */}

        <div className="product-price">

          <span className="new-price">
            ₹{finalPrice.toLocaleString("en-IN")}
          </span>

          {oldPrice && oldPrice > finalPrice && (
            <span className="old-price">
              ₹{oldPrice.toLocaleString("en-IN")}
            </span>
          )}

        </div>

        {/* BUTTONS */}

        <div className="product-buttons">

          <button
            type="button"
            className="cart-btn"
            onClick={handleAddToCart}
          >
            <FiShoppingCart />

            <span>
              {added ? "Added ✓" : "Add Cart"}
            </span>
          </button>

          <Link
            to={`/product/${product?.id}`}
            className="view-btn"
            aria-label={`View ${productName}`}
          >
            <FiEye />
          </Link>

        </div>

      </div>

    </div>
  );
};

export default ProductCard;
